import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import 'mapbox-gl/dist/mapbox-gl.css';
import './scss/styles.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';

import setup from './config/setup';
// import { GoogleAnalyticsProvider } from './utils/googleAnalytics';
import RetailerGuard from 'Layout/RetailerGuard';
import { AppProvider } from 'context/AppContext';
import { AuthProvider } from 'context/AuthContext';
import { SegmentProvider } from 'context/SegmentContext';
import { LogRocketProvider } from 'context/LogrocketContext';
import App from './App';
// import { unregister } from './registerServiceWorker';
//import registerServiceWorker from './registerServiceWorker';

setup();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    {/* <GoogleAnalyticsProvider> */}
    <AppProvider>
      <AuthProvider>
        <RetailerGuard>
          <LogRocketProvider>
            <SegmentProvider>
              <App />
            </SegmentProvider>
          </LogRocketProvider>
        </RetailerGuard>
      </AuthProvider>
    </AppProvider>
    {/* </GoogleAnalyticsProvider> */}
  </Router>
);

// unregister();
//registerServiceWorker();
